import workspaceQuery from '../../../graphql/queries/sales/ImportedPixSellOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedPixSellOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedPixSellOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedPixSellOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedPixSellOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedPixSellOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedPixSellOrderAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedPixSellOrder: EntityType = {
  type: 'ImportedPixSellOrder',
  title: 'PixSell Orders',
  formTitle: 'Imported PixSell Order',
  workspaceUrl: '/Sales/Channel/ImportedPixSellOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedPixSellOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_PIXSELL_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedPixSellOrder;
